/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import { Injectable } from "@angular/core";
import {
  Callback,
  IContent,
  IErrorObject,
  IQueryOption,
} from "../../../../types/platform/universe";
import { UpdatableService } from "../../platform/base/services/updatable.service";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";

import { retry } from "rxjs/operators";
import { Errors } from "../base/library/errors";

/**
 * todo
 */
@Injectable({
  providedIn: "root",
})
export class ShotdataService extends UpdatableService {
  constructor(public http: HttpClient) {
    super(http, "shots");
  }

  /**
   * @returns none
   */
  protected decorator(value: any): any {
    return value;
  }

  /**
   * カウント
   *
   * @param query MongoDBのクエリーオブジェクト
   * @param related
   * @param callback 結果数を返すコールバック
   */
  public pseudo_count(
    query: object,
    related: boolean,
    is_new: boolean,
    callback: Callback<number>
  ): void {
    this.Encode(query, (error: IErrorObject, queryString: string): void => {
      if (!error) {
        let api: string = "/pseudo_count/";
        if (related) {
          api = "/related_count/";
          if (is_new) {
            api = "/related_count2/";
          }
        } else {
          if (is_new) {
            api = "/pseudo_count2/";
          }
        }

        this.http
          .get(
            this.endPoint + "/" + this.model + api + queryString,
            this.httpOptions
          )
          .pipe(retry(3))
          .subscribe({
            next: (result: any): void => {
              if (result) {
                // Check if result has the standard platform format {code, message, value}
                if (this.isNumber(result.code)) {
                  if (result.code === 0) {
                    callback(null, result.value);
                  } else {
                    callback(Errors.serverError(result, "A00405"), 0);
                  }
                } else {
                  // Legacy format - direct value
                  callback(null, result);
                }
              } else {
                callback(Errors.networkError("A00405"), 0);
              }
            },
            error: (error: HttpErrorResponse): void => {
              callback(Errors.socketError(error, "A00406"), null);
            },
            complete: () => {},
          });
      } else {
        callback(Errors.responseError("A00407"), null);
      }
    });
  }

  /**
   * クエリー
   *
   * @param query MongoDBのクエリーオブジェクト
   * @param option MongoDBのオプションオブジェクト
   * @param related
   * @param callback 結果配列を返すコールバック
   */
  public pseudo_query(
    query: object,
    option: IQueryOption,
    related: boolean,
    is_new: boolean,
    callback: Callback<object[]>
  ): void {
    this.Encode(query, (error: IErrorObject, queryString: string): void => {
      if (!error) {
        this.Encode(
          option,
          (error: IErrorObject, optionString: string): void => {
            if (!error) {
              let api: string = "/pseudo_query/";
              if (related) {
                api = "/related_query/";
                if (is_new) {
                  api = "/related_query2/";
                }
              } else {
                if (is_new) {
                  api = "/pseudo_query2/";
                }
              }

              this.http
                .get(
                  this.endPoint +
                    "/" +
                    this.model +
                    api +
                    queryString +
                    "/" +
                    optionString,
                  this.httpOptions
                )
                .pipe(retry(3))
                .subscribe({
                  next: (result: any): void => {
                    if (result) {
                      if (this.isNumber(result.code)) {
                        if (result.code === 0) {
                          const results = result.value;
                          if (Array.isArray(results)) {
                            const filterd: any[] = [];
                            results.forEach((item) => {
                              filterd.push(this.decorator(item));
                            });
                            callback(null, filterd);
                          } else {
                            callback(
                              Errors.generalError(
                                result.code,
                                result.message || "Invalid data format",
                                "A00307"
                              ),
                              null
                            );
                          }
                        } else {
                          callback(Errors.serverError(result, "A00308"), null);
                        }
                      } else {
                        if (Array.isArray(result)) {
                          const filterd: any[] = [];
                          result.forEach((item) => {
                            filterd.push(this.decorator(item));
                          });
                          callback(null, filterd);
                        } else {
                          callback(
                            Errors.generalError(
                              -1,
                              "ログインしていません。",
                              "A00307"
                            ),
                            null
                          );
                        }
                      }
                    } else {
                      callback(Errors.networkError("A00402"), null);
                    }
                  },
                  error: (error: HttpErrorResponse): void => {
                    callback(Errors.socketError(error, "A00403"), null);
                  },
                  complete: () => {},
                });
            } else {
              callback(Errors.responseError("A00404"), null);
            }
          }
        );
      } else {
        callback(Errors.responseError("A00405"), null);
      }
    });
  }

  /**
   * レコード更新
   *
   * @param id レコードID
   * @param content 更新内容
   * @param callback コールバック
   */
  public put(id: string, content: IContent, callback: Callback<any>): void {
    this.http
      .put(
        this.endPoint + "/" + this.model + "/auth/" + encodeURIComponent(id),
        content,
        this.httpOptions
      )
      .pipe(retry(3))
      .subscribe({
        next: (result: any): void => {
          if (this.isNumber(result.code)) {
            if (result.code === 0) {
              callback(null, result.value);
            } else {
              callback(Errors.serverError(result, "A02837"), null);
            }
          } else {
            callback(Errors.httpError(500, "A00409"), null);
          }
        },
        error: (error: HttpErrorResponse): void => {
          callback(Errors.socketError(error, "A00410"), null);
        },
        complete: () => {},
      });
  }

  /**
   * todo
   */
  public delete(id: string, callback: Callback<any>): void {
    this.http
      .delete(
        this.endPoint +
          "/" +
          this.model +
          "/pseudo_delete/" +
          encodeURIComponent(id),
        this.httpOptions
      )
      .pipe(retry(3))
      .subscribe({
        next: (result: any): void => {
          if (this.isNumber(result.code)) {
            if (result.code === 0) {
              callback(null, result.value);
            } else {
              callback(Errors.serverError(result, "A02937"), null);
            }
          } else {
            callback(Errors.httpError(500, "A00411"), null);
          }
        },
        error: (error: HttpErrorResponse): void => {
          callback(Errors.socketError(error, "A00412"), null);
        },
        complete: () => {},
      });
  }

  public shotRequestAdvice(content: any, callback: Callback<any>): void {
    this.http
      .post(
        this.endPoint + "/" + this.model + "/shot-request-advice",
        content,
        this.httpOptions
      )
      .pipe(retry(3))
      .subscribe(
        (result: any): void => {
          if (result) {
            callback(null, result);
          } else {
            callback(Errors.networkError("A00405"), 0);
          }
        },
        (error: HttpErrorResponse): void => {
          callback(Errors.networkException(error, "A00406"), null);
        }
      );
  }
  public shotAVG(content: any, callback: Callback<any>): void {
    this.http
      .post(this.endPoint + "/shot", content, this.httpOptions)
      .pipe(retry(3))
      .subscribe(
        (result: any): void => {
          if (result) {
            callback(null, result);
          } else {
            callback(Errors.networkError("A00408"), 0);
          }
        },
        (error: HttpErrorResponse): void => {
          callback(Errors.networkException(error, "A00409"), null);
        }
      );
  }
  public shotDemo(content: any, callback: Callback<any>): void {
    this.http
      .post(
        this.endPoint + "/" + this.model + "/shot-memo",
        content,
        this.httpOptions
      )
      .pipe(retry(3))
      .subscribe(
        (result: any): void => {
          if (result) {
            callback(null, result);
          } else {
            callback(Errors.networkError("A00405"), 0);
          }
        },
        (error: HttpErrorResponse): void => {
          callback(Errors.networkException(error, "A00406"), null);
        }
      );
  }
}
